// Daily motivational quotes. Rotates by day-of-year so it changes each day.
export const QUOTES = {
  id: [
    "Sedikit demi sedikit, lama-lama menjadi bukit. Tetap konsisten!",
    "Tubuhmu bisa. Tinggal yakinkan pikiranmu.",
    "Jangan berhenti saat lelah, berhentilah saat selesai.",
    "Kemajuan kecil hari ini adalah kemenangan besar esok hari.",
    "Disiplin adalah jembatan antara tujuan dan pencapaian.",
    "Keringat hari ini adalah kekuatan hari esok.",
    "Kamu tidak harus hebat untuk memulai, tapi harus memulai untuk jadi hebat.",
    "Satu latihan lagi lebih baik daripada seribu alasan.",
    "Tumbuh itu tidak nyaman, tapi menyerah lebih menyakitkan.",
    "Fokus pada progres, bukan kesempurnaan.",
    "Setiap repetisi mendekatkanmu pada versi terbaik dirimu.",
    "Rasa malas itu sementara, kebanggaan itu selamanya.",
    "Bangun lebih kuat dari kemarin, bukan dari orang lain.",
    "Konsistensi mengalahkan intensitas. Muncul setiap hari.",
    "Jangan hitung harinya, buat harinya berarti.",
    "Percaya pada prosesnya, hasil akan menyusul.",
    "Tubuh yang kuat dibangun dari pikiran yang tak pantang menyerah.",
    "Hari ini berat, besok kamu akan berterima kasih pada dirimu.",
    "Batasmu hanyalah imajinasimu. Lampaui itu.",
    "Latihan bukan hukuman, tapi hadiah untuk tubuhmu.",
    "Mulailah dari mana kamu berada, gunakan apa yang kamu punya.",
    "Setiap juara dulunya adalah pemula yang tak berhenti mencoba.",
    "Energi yang kamu keluarkan hari ini akan kembali berlipat.",
    "Jadilah lebih baik 1% setiap hari.",
    "Kekuatan sejati datang dari melakukannya bahkan saat malas.",
    "Kesehatan adalah investasi, bukan pengeluaran.",
    "Ubah 'saya tidak bisa' menjadi 'saya pasti bisa'.",
    "Tidak ada jalan pintas menuju tempat yang layak dituju.",
    "Peluh, senyum, ulangi. Kamu sedang membangun sesuatu yang hebat.",
    "Jangan menyerah. Awal selalu yang paling sulit.",
  ],
  en: [
    "Little by little becomes a lot. Stay consistent!",
    "Your body can do it. Now convince your mind.",
    "Don't stop when you're tired. Stop when you're done.",
    "Small progress today is a big win tomorrow.",
    "Discipline is the bridge between goals and achievement.",
    "Today's sweat is tomorrow's strength.",
    "You don't have to be great to start, but you have to start to be great.",
    "One more workout beats a thousand excuses.",
    "Growth is uncomfortable, but quitting hurts more.",
    "Focus on progress, not perfection.",
    "Every rep brings you closer to your best self.",
    "Laziness is temporary, pride is forever.",
    "Compete with who you were yesterday, not with others.",
    "Consistency beats intensity. Just show up.",
    "Don't count the days, make the days count.",
    "Trust the process and the results will follow.",
    "A strong body is built by a mind that won't quit.",
    "Today is hard, tomorrow you'll thank yourself.",
    "Your only limit is your imagination. Break past it.",
    "Training isn't punishment, it's a gift to your body.",
    "Start where you are, use what you have.",
    "Every champion was once a beginner who kept going.",
    "The energy you give today comes back multiplied.",
    "Get 1% better every single day.",
    "Real strength is doing it even when you don't feel like it.",
    "Health is an investment, not an expense.",
    "Turn 'I can't' into 'I definitely can'.",
    "There are no shortcuts to any place worth going.",
    "Sweat, smile, repeat. You're building something great.",
    "Never give up. The start is always the hardest.",
  ],
};

export function dailyQuote(lang = "id") {
  const list = QUOTES[lang] || QUOTES.id;
  const now = new Date();
  const dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
  return list[dayOfYear % list.length];
}
